import * as React from "react";
import { classNames, throttle } from "../uitk-react-utils/index.js";
import { UitkToolbarAction, UitkToolbarContainer, UitkToolbarContent } from "./index.js";
export var ToolbarType = /* @__PURE__ */ ((ToolbarType2) => {
  ToolbarType2["CLOSE"] = "close";
  ToolbarType2["BACK"] = "arrow_back";
  return ToolbarType2;
})(ToolbarType || {});
export var ToolbarHeadingLevel = /* @__PURE__ */ ((ToolbarHeadingLevel2) => {
  ToolbarHeadingLevel2["ONE"] = "h1";
  ToolbarHeadingLevel2["TWO"] = "h2";
  ToolbarHeadingLevel2["THREE"] = "h3";
  ToolbarHeadingLevel2["FOUR"] = "h4";
  ToolbarHeadingLevel2["FIVE"] = "h5";
  ToolbarHeadingLevel2["SIX"] = "h6";
  return ToolbarHeadingLevel2;
})(ToolbarHeadingLevel || {});
export var ToolbarHeaderType = /* @__PURE__ */ ((ToolbarHeaderType2) => {
  ToolbarHeaderType2["OVERLAY"] = "Overlay";
  return ToolbarHeaderType2;
})(ToolbarHeaderType || {});
export class UitkToolbar extends React.Component {
  static displayName = "UitkToolbar";
  isElevatedToolbar;
  constructor(props) {
    super(props);
    this.state = {
      elevatedToolbar: false
    };
    this.isElevatedToolbar = false;
    this.handleScroll = throttle(100, this.handleScroll.bind(this));
  }
  componentDidUpdate() {
    const { contentDomRef } = this.props;
    const domRef = contentDomRef;
    if (domRef && domRef.current && typeof domRef.current.addEventListener === "function") {
      domRef.current.addEventListener("scroll", this.handleScroll);
    }
  }
  componentWillUnmount() {
    const { contentDomRef } = this.props;
    const domRef = contentDomRef;
    if (domRef && domRef.current && typeof domRef.current.removeEventListener === "function") {
      domRef.current.removeEventListener("scroll", this.handleScroll);
    }
  }
  handleScroll(event) {
    if (event.target.scrollTop > 0) {
      if (!this.isElevatedToolbar) {
        this.toggleElevatedState(true);
      }
    } else {
      this.toggleElevatedState(false);
    }
  }
  toggleElevatedState(isElevated) {
    this.setState(
      {
        elevatedToolbar: isElevated
      },
      () => {
        this.isElevatedToolbar = isElevated;
      }
    );
  }
  render() {
    const {
      actionInlineStart,
      actionInlineStartContent,
      actionContent,
      actionInlineEnd,
      analytics,
      buttonRefInlineStart,
      buttonRefInlineEnd,
      className,
      header,
      headingLevel,
      iconLabelInlineStart,
      iconLabelInlineEnd,
      id,
      subtext,
      typeInlineStart,
      typeInlineEnd,
      overlap,
      toolbarHeaderType,
      style
    } = this.props;
    const { elevatedToolbar } = this.state;
    const wrapperClassNames = classNames(className, {
      elevated: elevatedToolbar,
      "uitk-toolbar-overlap": overlap
    });
    const Heading = headingLevel || "h2" /* TWO */;
    const toolbarContentCssClasses = classNames(
      "uitk-toolbar-title",
      "truncate",
      `${toolbarHeaderType === "Overlay" /* OVERLAY */ ? "uitk-toolbar-overlay-heading" : ""}`
    );
    return /* @__PURE__ */ React.createElement(UitkToolbarContainer, { className: wrapperClassNames, style }, actionInlineStart ? /* @__PURE__ */ React.createElement(
      UitkToolbarAction,
      {
        action: actionInlineStart,
        actionContent: actionInlineStartContent,
        analytics: analytics && {
          localAnalyticsId: "Close",
          ...analytics
        },
        buttonRef: buttonRefInlineStart,
        iconLabel: iconLabelInlineStart,
        type: typeInlineStart ?? "arrow_back" /* BACK */,
        toolbarType: toolbarHeaderType,
        id: `${id}-action-start`
      }
    ) : /* @__PURE__ */ React.createElement(React.Fragment, null), /* @__PURE__ */ React.createElement(UitkToolbarContent, { className: classNames("uitk-toolbar-text"), grow: 1 }, header && /* @__PURE__ */ React.createElement(Heading, { className: toolbarContentCssClasses }, header), subtext && /* @__PURE__ */ React.createElement("p", { className: classNames("uitk-toolbar-subtitle truncate") }, subtext)), actionContent, actionInlineEnd ? /* @__PURE__ */ React.createElement(
      UitkToolbarAction,
      {
        action: actionInlineEnd,
        analytics: analytics && {
          localAnalyticsId: "Close",
          ...analytics
        },
        buttonRef: buttonRefInlineEnd,
        iconLabel: iconLabelInlineEnd,
        type: typeInlineEnd ?? "close" /* CLOSE */,
        toolbarType: toolbarHeaderType,
        id: `${id}-action-end`
      }
    ) : /* @__PURE__ */ React.createElement(React.Fragment, null));
  }
}
